import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Container, Nav, Navbar, Offcanvas, Image } from "react-bootstrap";
import { ContactContext } from "../context/ContactContext";
import SocialIcons from "../components/SocialIcons";
import phoneIcon from "../assets/images/phone.svg";
import mailIcon from "../assets/images/mail.svg";
import '../assets/scss/sections/header.scss';

function Header() {
    const contact = useContext(ContactContext);
    const phoneNumbers = contact?.phone_number
        ? contact?.phone_number.replaceAll(' ', '').split(',')
        : [];
    const email = contact?.email;

    return (
        <Navbar collapseOnSelect expand="lg" id="nav-section" as="header" className="py-2 py-md-4">
            <Container>
                <Navbar.Brand href="/">
                    <Image
                    src="/logo2.png"
                    className="logo"
                    alt="logo"
                    width="42"
                    height="42"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" />
                <Navbar.Offcanvas
                    id="offcanvasNavbar-expand-lg"
                    aria-labelledby="offcanvasNavbarLabel-expand-md"
                    placement="end"
                    className='navbar-light'
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                          Menu
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link
                                as={NavLink}
                                to="/"
                                eventKey="home" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Home
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="/about"
                                eventKey="about" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                About Us
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="/properties"
                                eventKey="listings" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Properties
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="/contact"
                                eventKey="contact" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Contact Us
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="/inquiry"
                                eventKey="inquiry" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Inquiry Form
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="/careers"
                                eventKey="careers" // Triggers onSelect event to activate collapseOnSelect
                                className={( { isActive }) => "header-nav-link" + (isActive ? " active" : "")}
                            >
                                Careers
                            </Nav.Link>

                            {/* Contact links for collapsed view - includes icons and text */}
                            { (phoneNumbers && email) &&
                                <div id="nav-contact" className="d-lg-none mt-4 mb-2">
                                    <Image src={ phoneIcon } width="20" height="19" className="d-inline me-2" />

                                    {/* Phone numbers */}
                                    {phoneNumbers.map((number, index) => (
                                        <Nav.Link key={index} href={ `tel:${number}` } className="d-inline">
                                            { number }
                                            { index < phoneNumbers.length - 1 && ", " }{/* Add comma if not the last element */}
                                        </Nav.Link>
                                    ))}

                                    {/* Email */}
                                    <Nav.Link href={`mailto:${email}`} className="d-lg-none mt-2 mb-4">
                                        <Image src={ mailIcon } width="20" height="19" className="me-2" />{ email }
                                    </Nav.Link>

                                    <SocialIcons links={ contact && contact?.social_links} />
                                </div>
                            }
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>

                {/* Contact links for desktop view - only icons */}
                <Nav className="d-none d-lg-flex">
                    { (phoneNumbers && email) && 
                        <>
                            <Nav.Link href={ `tel:${phoneNumbers[0]}` }  className="px-2">
                                <Image src={ phoneIcon } width="20" height="19" />
                            </Nav.Link>
                            <Nav.Link href={ `mailto:${email}` } className="px-2">
                                <Image src={ mailIcon } width="20" height="19" />
                            </Nav.Link>
                        </>
                    }
                </Nav>
            </Container>
        </Navbar>
    );
};

export default Header;
